import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import filterIcon from "../../assets/filterStroke.svg";
import NoData from "../NoData/NoData";

const mock = {
  status: "success",
  detail: "Agents created successfully",
  records:
    "|   # | Agent Category             | Agent Name                          | Description of Individual Agents                                                                                   | Agent Type   | Agent Version   | Provider                         | LLM Model            | Documentation URL (if available)      | Agent Skills                                                                                                                                                                                                                                                                                                        | Industry                 | Sector       | Sample Prompt                                                                                                      | Business Function                                                                                                                          | Key POC        |\n|----:|:---------------------------|:------------------------------------|:-------------------------------------------------------------------------------------------------------------------|:-------------|:----------------|:---------------------------------|:---------------------|:--------------------------------------|:--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|:-------------------------|:-------------|:-------------------------------------------------------------------------------------------------------------------|:-------------------------------------------------------------------------------------------------------------------------------------------|:---------------|\n|   1 | HR                         | HRPolicyAgent                       | Answers Questions on the HR policy documentation                                                                   | Custom_Agent | v1              | GCP                              | gemini-2.0-flash-001 | Google NEXT '25 Asset Onboarding.pptx | HR Policy QA| HR Skill2                                                                                                                                                                                                                                                                                             | Cross Industry           | Cross Sector | Any questions on any HR Policy documents can be asked.                                                             | Cross-domain                                                                                                                               | Ashish Agarwal |\n|   2 | Customer Experience        | Customer Context Agent              | Fetches customer's styles and color preferences.                                                                   | Custom_Agent | v1              | GCP                              | gemini-2.0-flash-001 | Google NEXT '25 Asset Onboarding.pptx | Fetches customer's styles and color preferences.                                                                                                                                                                                                                                                                    | Consumer                 |              | Need outfit recommendations for my anniversary dinner next week this day at Daniel, New York                       | Customer Experience                                                                                                                        | Ashish Agarwal |\n|   3 | Customer Experience        | Event Context Agent                 | Event Context Agent - Fetches necessary details regarding the occasion.                                            | Custom_Agent | v1              | GCP                              | gemini-2.0-flash-001 | Google NEXT '25 Asset Onboarding.pptx | Fetches necessary details regarding the occasion.                                                                                                                                                                                                                                                                   | Consumer                 |              | I saw this image of my celebrity idol in insta and i really liked their outfit. Where can i find similar clothes ? | Customer Experience                                                                                                                        | Ashish Agarwal |",
};

const ProcessedData = ({ type, data }) => {
  const tableStyles = {
    tableContainerSx: {
      maxHeight: 440,
      boxShadow: "none",
      border: "1px solid var(--db-secondary-gray-six)",
      "& .MuiTableCell-root": {
        borderRight: "none",
        borderLeft: "none",
      },
    },
    tableSx: {
      borderCollapse: "separate",
      borderSpacing: "0",
      alignItems: "center",
    },
    tableCellSx: {
      fontWeight: "bold",
      backgroundColor: "var(--db-secondary-gray-fourteen)",
      borderRight: "none",
      fontSize: "12px",
      padding: "8px",
    },
  };

  const parseMarkdownTable = (markdownTable) => {
    if (!markdownTable || typeof markdownTable !== "string") {
      console.warn("Invalid markdown table data");
      return [];
    }

    const lines = markdownTable.trim().split("\n");

    if (lines.length < 3) {
      console.warn("Insufficient table data - need at least 3 lines");
      return [];
    }

    const headers = lines[0]
      .split("|")
      .map((h) => h.trim())
      .filter((h) => h);

    if (headers.length === 0) {
      console.warn("No valid headers found");
      return [];
    }

    const rows = lines.slice(2);

    const processedRows = rows
      .map((row, rowIndex) => {
        const cells = row
          .split("|")
          .map((cell) => cell.trim())
          .filter((cell) => cell);

        const rowObj = {
          _rowId: `row_${rowIndex}`,
          _originalRowIndex: rowIndex,
        };

        headers.forEach((header, headerIndex) => {
          rowObj[header] = cells[headerIndex] || "";

          if (headerIndex >= headers.length && cells[headerIndex]) {
            rowObj[`extra_column_${headerIndex}`] = cells[headerIndex];
          }
        });

        return rowObj;
      })
      .filter((row) => {
        const dataValues = Object.entries(row)
          .filter(([key, value]) => !key.startsWith("_"))
          .map(([_, value]) => value)
          .filter((value) => value !== "");

        return dataValues.length > 0;
      });

    return processedRows;
  };

  const parsedData = parseMarkdownTable(mock?.records || "");

  const headers =
    parsedData.length > 0
      ? Object.keys(parsedData[0]).filter((key) => !key.startsWith("_"))
      : [];

  const tableStats = {
    totalColumns: headers.length,
    totalRows: parsedData.length,
    totalCells: headers.length * parsedData.length,
    hasData: parsedData.length > 0 && headers.length > 0,
  };

  return (
    <div>
      {/* Uploaded Data Table */}
      <div className="processed-data-container">
        {tableStats?.hasData ? (
          <TableContainer
            component={Paper}
            style={{ scrollbarWidth: "thin" }}
            sx={tableStyles?.tableContainerSx}
          >
            <Table
              stickyHeader
              aria-label="processed_data_table"
              sx={tableStyles?.tableSx}
            >
              <TableHead>
                <TableRow>
                  {/* DYNAMIC: Render any number of headers */}
                  {headers.map((header, index) => (
                    <TableCell
                      key={`header_${index}`}
                      sx={tableStyles?.tableCellSx}
                    >
                      <div
                        className="upload-col"
                        onClick={(e) => e.stopPropagation()}
                        title={`Column: ${header}`}
                      >
                        {header}
                        <img src={filterIcon} alt="Filter Icon" />
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* DYNAMIC: Render any number of rows and cells */}
                {parsedData.map((row, rowIdx) => (
                  <TableRow key={row._rowId || `row_${rowIdx}`} hover>
                    {headers.map((header, cellIdx) => {
                      const cellValue = row[header];
                      const isEmpty = !cellValue || cellValue.trim() === "";

                      return (
                        <TableCell
                          key={`cell_${rowIdx}_${cellIdx}`}
                          sx={{
                            fontSize: "11px",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            backgroundColor: isEmpty ? "#fafafa" : "inherit",
                            fontStyle: isEmpty ? "italic" : "normal",
                            color: isEmpty ? "#999" : "inherit",
                          }}
                          title={cellValue || "Empty cell"}
                        >
                          {isEmpty ? "-" : cellValue}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <div className="error-no-data">
            <NoData main={"Valid Table"} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProcessedData;
